<template>

  <div id="resources">

    <!-- Title Section -->
    <div class="container">
      <div class="row align-items-center">
        <div class="col-sm mb-3 mt-3 mb-sm-0">
          <h1 class="h2 mb-0">Liste des ressources ({{ resources.length }} disponibles) </h1>
        </div>
      </div>
      <!-- End Row -->
    </div>
    <!-- End Title Section -->

    <!-- Properties Section -->
    <div class="container space-1 space-bottom-lg-3">

      <div class="row">

        <div class="col-12">
          <!-- Resources -->
          <div class="row mb-5">

            <div class="col-sm-6 col-lg-4 mb-3"
                 v-for="resource in resources" :key="resource.id">
              <!-- Property Item -->
              <div class="card card-bordered">
                <a :href=" '/module/dlnkresources/resource?resource_id=' + resource.id ">
                  <img class="card-img-top w-100" :src="resource.default_picture_url"
                       :alt="'Image du ' + resource.type">
                </a>
                <!-- Body -->
                <div class="card-body">
                  <span class="d-block font-size-1 text-body">{{ resource.status }}</span>

                  <div class="row align-items-center">
                    <div class="col">
                      <h4 class="text-hover-primary"><a
                          :href=" '/module/dlnkresources/resource?resource_id=' + resource.id "
                          class="text-primary">{{ resource.name }}</a></h4>
                    </div>
                    <div class="col-auto" v-if="resource.price > 0">
                      <h3 class="text-primary">{{ resource.price }}€</h3>
                    </div>
                  </div>

                  <div class="mb-2">
                    <a :href=" '/module/dlnkresources/resource?resource_id=' + resource.id "
                        class="btn btn-block btn-sm btn-primary btn-wide transition-3d-hover text-white">
                      Réserver
                    </a>
                  </div>
<!--                  <ul class="list-inline list-separator font-size-1 text-body">-->
<!--                    <li class="list-inline-item">-->
<!--                      <a class="btn btn-primary btn-xs btn-icon rounded-circle"><i class="fas fa-info-circle"></i></a>-->
<!--                    </li>-->
<!--                  </ul>-->
                </div>
                <!-- End Body -->
              </div>
              <!-- End Property Item -->
            </div>

          </div>
          <!-- End Resources -->
        </div>

      </div>
    </div>
    <!-- End Properties Section -->
  </div>


</template>

<script>

export default {
  props: ['api_url', 'customer_id'],
  data: function () {
    return {
      resources: [],
      resource_types: [],
      resource_places: [],
      query: '',
      order_by: 'date',
      order_direction: 'asc',
      company: Object,
      is_admin: Boolean,
      method: 'post',
    }
  },
  mounted() {
    this.get_resources();
    this.get_resource_types();
    this.get_places();
    // INITIALIZATION OF ION RANGE SLIDER
    // =======================================================
    $('.js-ion-range-slider').each(function () {
      var ionRangeSlider = $.HSCore.components.HSIonRangeSlider.init($(this));
    });


  },

  computed: {
    submit_disabled: function () {
      return false;
    }
  },

  methods: {
    get_places: async function () {
      const _this = this
      const secure_key = await get_token();
      let url = this.api_url + '/resource_places.json'

      url += '?secure_key=' + secure_key;
      url += '&customer_id=' + _this.customer_id;

      axios.get(url)
          .then(function (response) {
            if (response.status == 200) {
              _this.resource_places = response.data
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_resources: async function () {
      const _this = this
      const secure_key = await get_token();
      let url = this.api_url + '/resources.json'

      url += '?secure_key=' + secure_key;
      url += '&customer_id=' + _this.customer_id;

      axios.get(url)
          .then(function (response) {
            if (response.status == 200) {
              _this.resources = response.data
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_resource_types: async function () {
      const _this = this
      const secure_key = await get_token();
      let url = this.api_url + '/resource_types.json'

      url += '?secure_key=' + secure_key;
      url += '&customer_id=' + _this.customer_id;

      axios.get(url)
          .then(function (response) {
            if (response.status == 200) {
              _this.resource_types = response.data
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },
  },
}
</script>